import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SyncResultPage } from '@features/admin/sync-result';
import { useAdminSyncResultStore } from '@features/admin/sync-result/useAdminSyncResultStore.ts';

const adminSyncResultSearchSchema = z.object({
  syncType: z.string().optional(),
  outcome: z.enum(['CREATED', 'UPDATED', 'CONFIRMED', 'SKIPPED', 'FAILED', 'DELETED']).optional(),
  sourceId: z.string().optional(),
  syncRequestId: z.coerce.number().optional(),
  // Autor ze zdrojového systému — substring, ILIKE.
  author: z.string().optional(),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
});

export type AdminSyncResultSearch = z.infer<typeof adminSyncResultSearchSchema>;

export const Route = createFileRoute('/admin/sync-result/')({
  validateSearch: search => adminSyncResultSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { syncType, outcome, sourceId, syncRequestId, author, page, size } = ctx.search;
    useAdminSyncResultStore.getState().loadSyncResults({
      syncType,
      outcome,
      sourceId,
      syncRequestId,
      author,
      page: page || 1,
      size: size || 20,
    });
  },
});

function RouteComponent() {
  return <SyncResultPage />;
}
